import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppComponent } from './app.component';

const routes: Routes = [
  { path: ':id', component: AppComponent }, // Dynamic route must come first
  { path: '**', redirectTo: '', pathMatch: 'full' }, // Wildcard route must come last

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
